import { render, staticRenderFns } from "./onlineTestList.vue?vue&type=template&id=829bcebe&scoped=true"
import script from "./onlineTestList.vue?vue&type=script&lang=js"
export * from "./onlineTestList.vue?vue&type=script&lang=js"
import style0 from "./onlineTestList.vue?vue&type=style&index=0&id=829bcebe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829bcebe",
  null
  
)

export default component.exports